import { clsx } from 'clsx';
import type { SVGProps } from 'react';

export interface SpinnerProps extends Omit<SVGProps<SVGSVGElement>, 'children' | 'viewBox'> {
  /** Width/height in px. Default 20. */
  size?: number;
  /** Accessible name. Omit when a parent already announces the busy state (e.g. `aria-busy`). */
  label?: string;
}

/**
 * Inline loading indicator. Rotates with `transform`; under reduced motion it pulses softly instead
 * (see `.spinner` in styles/components/controls.css). Inherits `currentColor`.
 */
export function Spinner({ size = 20, label, className, ...props }: SpinnerProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={clsx('spinner', className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      {...props}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2.5" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
